// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimCoveragePeriodDto
 */
export interface IClaimCoveragePeriodDto {
    /**
     * 
     * @type {Date}
     * @memberof IClaimCoveragePeriodDto
     */
    coverage_date_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimCoveragePeriodDto
     */
    coverage_date_end?: Date;
}

/**
 * Check if a given object implements the IClaimCoveragePeriodDto interface.
 */
export function instanceOfIClaimCoveragePeriodDto(value: object): value is IClaimCoveragePeriodDto {
    return true;
}

export function IClaimCoveragePeriodDtoFromJSON(json: any): IClaimCoveragePeriodDto {
    return IClaimCoveragePeriodDtoFromJSONTyped(json, false);
}

export function IClaimCoveragePeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimCoveragePeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage_date_start': json['coverage_date_start'] == null ? undefined : (new Date(json['coverage_date_start'])),
        'coverage_date_end': json['coverage_date_end'] == null ? undefined : (new Date(json['coverage_date_end'])),
    };
}

export function IClaimCoveragePeriodDtoToJSON(json: any): IClaimCoveragePeriodDto {
    return IClaimCoveragePeriodDtoToJSONTyped(json, false);
}

export function IClaimCoveragePeriodDtoToJSONTyped(value?: IClaimCoveragePeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coverage_date_start': value['coverage_date_start'] == null ? undefined : ((value['coverage_date_start']).toISOString().substring(0,10)),
        'coverage_date_end': value['coverage_date_end'] == null ? undefined : ((value['coverage_date_end']).toISOString().substring(0,10)),
    };
}

